import React from 'react'
import cx from 'classnames'
import columns from './columns'

export default function BadgingTable(props) {
  const {
    reportData, 
    selectedRows, 
    selectedCells, 
    isTableChecked,
    toggleTable,
    toggleColumn,
    toggleRow,
    toggleCell,
  } = props;

  return (
    <table className='badgingTable'>
      <thead>
        <tr className='badgingTableHeaderRow badgingTableRow'>
          <th style={{ width: 40 }} className='badgingTableHeaderCell'>
            <input
              type="checkbox"
              checked={isTableChecked}
              onChange={toggleTable}
            />
          </th>
          {columns.map(col => {
            const className = cx({
              'badgingTableHeaderCell': true,
              'badgingTableHeaderClickable': col.badgeTypeId
            })
            return (
              <th 
                key={col.label}
                className={className}
                onClick={() => toggleColumn(col.badgeTypeId)}
              >
                {col.label}
              </th>
            )
          })}
        </tr>
      </thead>   
      <tbody>
        {reportData.map((row) => {
          row.studentCellSelection = selectedCells[row.studentId] || []
          row.toggleCell = toggleCell;
          return (
            <tr key={row.studentId} className='badgingTableRow'>
              <td className='badgingTableCell' style={{ textAlign: "center" }}>
                <input 
                  type="checkbox"
                  checked={selectedRows.includes(row.studentId)}
                  onChange={() => toggleRow(row.studentId)} 
                />
              </td>
              {columns.map(col => {
                let className = 'badgingTableCell ';
                if (col.cellClassName) className += col.cellClassName;
                return (
                  <td className={className} key={col.label}>
                    {col.render(row)}
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}